import type { RecordingSegmentPayload } from '@Application/Beneficiaries/Interviews/transferRecordingSegment';

export type RecordingSegmentsFetchedAction = {
	type: 'RECORDING_SEGMENTS_FETCHED';
	payload: RecordingSegmentPayload[];
	interviewId: number;
	recordingId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: RecordingSegmentPayload[],
	interviewId: number,
	recordingId: number,
	typeKey: string,
	subjectId: number,
): RecordingSegmentsFetchedAction => ({
	type: 'RECORDING_SEGMENTS_FETCHED',
	payload,
	interviewId,
	recordingId,
	typeKey,
	subjectId,
});
